/**
 * The goal of this function is to create grouping key for complex object.
 * Sometimes, when grouping columns with AgGrid, we need more than one field
 * to group data. For example, an amount is linked to a currency, thus, the
 * same amount in two different currencies shouldn't be grouped together.
 */
export function objectKeyCreator(params) {
    return JSON.stringify(params.value);
}
